import React from "react";
import colorSharp from "../assets/img/color-sharp.png";
import {
  Html5Icon,
  Css3Icon,
  TailwindIcon,
  JsIcon,
  CIcon,
  CodeIcon,
  MySqlIcon,
  MongoDbIcon,
  ReactIcon,
  NodeJsIcon,
  NextJsIcon,
  PhpIcon,
  GitIcon,
  ThreeJsIcon,
  UnrealIcon,
  UnityIcon,
  ResolveIcon,
  AdobeIcon,
} from './icons';


const Skills = () => {
  const skills = [
    { Icon: Html5Icon},
    { Icon: Css3Icon},
    { Icon: TailwindIcon},
    { Icon: JsIcon},
    { Icon: CIcon},
    { Icon: CodeIcon},
    { Icon: MySqlIcon},
    { Icon: MongoDbIcon},
    { Icon: ReactIcon},
    { Icon: NodeJsIcon},
    { Icon: NextJsIcon},
    { Icon: PhpIcon},
    { Icon: GitIcon},
    { Icon: ThreeJsIcon},
    { Icon: UnrealIcon},
    { Icon: UnityIcon},
    { Icon: ResolveIcon},
    { Icon: AdobeIcon},
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx">
              <h2>Skills</h2>
              <p>
                <br />
                As a web developer, I specialize in the following technologies:
              </p>
              <div className="row skill-list">
                {skills.map(({ Icon }, index) => (
                  <div className="col-md-4 mb-4" key={index}>
                    <div className="skill-item">
                      <div className="icon-container">
                        <div className="purple-circle">
                          <Icon className="icon-image" style={{ transition: "transform 0.3s ease-in-out" }} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Colorful Sharp" />
      {/* Add the CSS styles for the rotation effect */}
    </section>
  );
};

export { Skills };






